import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PageList from '../../../components/PageListAPI'
import { journalCategoriesGetList, journalCategoriesDeleteById } from '../../../api/list'

export default function JournalCategoriesList() {
  const location = useLocation()
  const history = useHistory()
  return <div className='App-paper'>
    <PageList
      title='Категории журналов'
      name='journal_categories-list'
      columns={[{ id: 'code', name: 'Код', width:50 }, { id: 'name', name: 'Наименование' }]}
      createItem={true}
      deleteItem={true}
      loadAPI={{
        request: journalCategoriesGetList,
      }}
      deleteAPI={journalCategoriesDeleteById}
      headerInit={{
        sortBy: 'code',
        sortDirection: 'desc',
      }}
      location={location}
      history={history}
      click={false}
    />
  </div>
}